class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    setTimeout(() => {
      const radios = this.querySelectorAll('.option-wrap.size .variant-row-list input[type="radio"]');
      if (radios.length === 1 && !radios[0].checked) {
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 0);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    var sold_out_btn = document.querySelector(".product-addcart");
    if(this.currentVariant != undefined){
     if (!this.currentVariant.available) {
       setTimeout(() => {
          sold_out_btn.classList.add('sold_out');
       }, "550")
      } else {
         setTimeout(() => {
          sold_out_btn.classList.remove('sold_out');
         }, "550")
      } 
    }
    if (!addButton) return;
    if (disable) {
      // addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('klaviyo-bis-trigger');
      // addButton.classList.add('sold_out');
      if (text) addButtonText.textContent = text;
    } else {
      // addButton.removeAttribute('disabled');
      addButton.classList.remove('klaviyo-bis-trigger');
      addButtonText.textContent = window.variantStrings.addToCart;
      // addButton.classList.remove('sold_out');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
// document.querySelector('.product-addcart').addEventListener('click',function(evt){
//   evt.preventDefault();
//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   var cartform = document.querySelector('.product-addcart').closest('form');
//   const formData = new FormData(cartform);  
//   config.body = formData;
//   fetch(`${routes.cart_add_url}`, config)
//   .then((response) => response.json())
//   .then((data) => {
//     if (data.status) {
//       document.querySelector('.product-form-error').innerHTML = data.description;
//       setTimeout(function(e){
//         document.querySelector('.product-form-error').innerHTML  = '';
//       },2000);
//       return;
//     }else{
//       if(typeof load_cart == 'function'){       
          
//               var option_price = Shopify.formatMoney(data.final_price); 
//               data.options_with_values.forEach(function (option) {
//                 if(option.name == "Color") {
//                   option_color = option.value;
//                 }
//                 if(option.name == "Size") {
//                   option_size = option.value; 
//                 }
//               });
//         var pro_title = data.product_title.split("|")[0].split("-")[0];
//               document.querySelector("#cart-notification-product").innerHTML = "";        
//               document.querySelector("#cart-notification-product").innerHTML = 
//               `<div class="main_notification row">
//                 <div class="lef_notification">
//                   <img src="${data.featured_image.url}" alt="${data.featured_image.alt}">
//                 </div>
//                 <div class="center_notification">
//                   <div>
//                   <p>${pro_title}</p>
//                   <div class="pro_var mt-6">
//                     <div class="singal_var">${option_size} / ${option_color}</div>
//                   </div>
//                 </div>
//                 </div>
//                 <div class="right_notification">
//                   <div class="cart-price">${option_price}</div>
//                 </div>
//               </div>`;
          

//           setTimeout(() => {
//             $('.main_cart_notification').addClass('active');
//           }, "1500")
//           setTimeout(() => {
//             $('.main_cart_notification.active').removeClass('active');
//           }, "5000")

//         load_cart();
//         // setTimeout(function(e){
//         //   document.querySelector('body').classList.add('open-drawer');
//         // },500);
//       }else{
//         window.location.href = "/cart";
//       }
//     }
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {

//   });
// });


document.querySelectorAll('.product-addcart').forEach(button => {
  button.addEventListener('click', async function(evt) {
    evt.preventDefault();

    const isMultiple = button.classList.contains('product-addcart-multiple');
    const freeProductId = button.dataset.id;

    const freeTitle = button.dataset.freeTitle || 'Free Product';
    const freeImage = button.dataset.freeImage || '/path/to/default-image.jpg';
    const freeColor = button.dataset.freeColor || '';

    const cartForm = button.closest('form');
    const mainProductId = cartForm.querySelector('[name="id"]').value;
    const mainQty = cartForm.querySelector('[name="quantity"]')?.value || 1;

    // Check cart for free product
    let addFree = true;
    if (isMultiple && freeProductId) {
      try {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        addFree = !cartData.items.some(item => item.id == freeProductId);
      } catch (err) {
        console.error(err);
      }
    }

    // Build FormData
    const formData = new FormData();
    formData.append('items[0][id]', mainProductId);
    formData.append('items[0][quantity]', mainQty);

    if (isMultiple && freeProductId && addFree) {
      formData.append('items[1][id]', freeProductId);
      formData.append('items[1][quantity]', 1);
    }

    // Add to cart
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch('/cart/add.js', config)
      .then(res => res.json())
      .then(data => {
        // Build popup
        let notificationHTML = '';

        // Main product (first item)
        const mainItem = data.items ? data.items[0] : data;
        const mainTitle = mainItem.product_title || 'Product';
        const mainImage = mainItem.featured_image?.url || '';
        const mainPrice = mainItem.final_price ? Shopify.formatMoney(mainItem.final_price) : '';
        let freeTitleLiquid = document.querySelector("#cart-notification-product").dataset.freetitle;
        let optionColor = '', optionSize = '';
        if (mainItem.options_with_values) {
          mainItem.options_with_values.forEach(option => {
            if(option.name == "Color") optionColor = option.value;
            if(option.name == "Size") optionSize = option.value;
          });
        }

        notificationHTML += `
          <div class="main_notification row">
            <div class="lef_notification">
              <img src="${mainImage}" alt="${mainTitle}">
            </div>
            <div class="center_notification">
              <div>
                <p>${mainTitle}</p>
                <div class="pro_var mt-6">
                  <div class="singal_var">${optionSize} / ${optionColor}</div>
                </div>
              </div>
            </div>
            <div class="right_notification">
              <div class="cart-price">${mainPrice}</div>
            </div>
          </div>
        `;
if (window.innerWidth > 767) {
        // Free product
        if (isMultiple && freeProductId && addFree) {
          notificationHTML += `
            <div class="free-pdt-row">
              <div class="lef_notification">
                <img src="${freeImage}" alt="${freeTitle}">
              </div>
              <div class="right-text">
                <div class="pdt-name">${freeTitleLiquid}</div>
                <div class="color">${freeColor}</div>
              </div>
            </div>
          `;
        }
}
        document.querySelector("#cart-notification-product").innerHTML = notificationHTML;

        setTimeout(() => {
          $('.main_cart_notification').addClass('active');
        }, 1500);

        setTimeout(() => {
          $('.main_cart_notification.active').removeClass('active');
        }, 5000);

        if (typeof load_cart === 'function') load_cart();
      })
      .catch(e => console.error(e));
  });
});


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}


const colorSelectItems = document.querySelectorAll(".color_select_img li");

colorSelectItems.forEach(function(item) {
  item.addEventListener("mouseenter", function() {

    this.classList.add("active_hover");
    this.closest("ul").classList.add("hover_active");
    document.querySelector('.pro_color_var span').textContent = this.dataset.color;
  });

  item.addEventListener("mouseleave", function() {
    this.classList.remove("active_hover");
    this.closest("ul").classList.remove("hover_active");
    const activeItem = document.querySelector('.color_select_img li.active');
    if (activeItem) {
      document.querySelector('.pro_color_var span').textContent = activeItem.dataset.color;
    }
  });
});

// const imageContainer = document.querySelector('.medialist');
// const images = imageContainer.querySelectorAll('.media-grid-column');
// const checkViewportButton = document.querySelector('.desk_zoom');

// function isElementInViewport(element) {
//   const rect = element.getBoundingClientRect();
  
//   return (
//     rect.top >= 0 &&
//     rect.bottom / 2 <= (window.innerHeight) 
//   );
// }

// function checkImagesInViewport() {
//   images.forEach((image, index) => {
//     if (isElementInViewport(image)) {
//       // Highlight or display the image that is in the viewport
// console.log(image);
//       image.classList.add('active');
//     } else {
//       // Remove any previous highlighting
//       if(image.classList.contains("active")){
//         image.classList.remove('active');
//       }
//     }
//   });
// }

// checkViewportButton.addEventListener('click', checkImagesInViewport);

$(document).on('click', '.main_wear_it .variant-single', function () {
    // Remove 'focus' class from all variant elements
    $('.main_wear_it .variant-single').removeClass('focus');
    
    $(this).addClass('focus');
    $('.custom-add-to-cart').addClass('none');
    $(this).closest('.singal_wear_it').find('.custom-add-to-cart').removeClass('none');
    var dataId = $(this).data('id');
    $(this).closest('.singal_wear_it').find('.custom-add-to-cart .btn-add').data('id', dataId);
});

$(document).on('click', '.singal_var', function () {
   $('.disable').removeClass('disable');
});
